// @ts-nocheck
import React, { useState } from 'react'
import Image, { ImageProps } from 'next/image'

interface Props extends ImageProps {
  src: string
  onClick: () => void
  alt: string
}

const CustomImage = ({ src, onClick, alt, layout, ...props }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(true)

  return (
    <>
      {error && <></>}
      <Image
        src={src}
        layout={layout}
        alt={alt}
        onLoadingComplete={() => setIsLoading(false)}
        onError={() => {
          setError(true)
          setIsLoading(false)
        }}
        onClick={onClick}
        {...props}
      />
      {isLoading && (
        <div style={{ width: '100%', height: '100%' }} className="skeleton" />
      )}
    </>
  )
}

export default CustomImage
